<script setup lang="ts">
import Preview from "../../base-components/Preview";
import Alert from "../../base-components/Alert";
import Lucide from "../../base-components/Lucide";
import {userUserStore} from "../../stores/user";
import {EmpresaGestion} from "@fixeduy/fixedtypes";
import {Ref, ref} from "vue";

const empresa: Ref<EmpresaGestion | null> = ref(null);

const userStore = userUserStore();
const mostrarAlerta = ref(true);

const cerrarAlerta = () => {
  mostrarAlerta.value = false;
};
</script>

<template>
  <template v-if="mostrarAlerta && userStore.desdeiMin">
    <Alert variant="danger" class="mb-2 my-4">
      <button @click="cerrarAlerta" class="absolute top-0 right-0 mt-2 mr-2">
        <Lucide icon="X" class="w-5 h-5" />
      </button>
      <Preview>
        <div>
          <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px">
            <span style="font-size: 2rem">📱</span>
            <h2 style="margin: 0; font-size: 1.4rem; font-weight: 700">¡Nueva app disponible!</h2>
          </div>
          <ul>
            <li>Disponible para Android</li>
            <li>Notificaciones en tiempo real</li>
            <li>
              Interfaz optimizada para dispositivos móviles, con integracion especial a la impresora de tu equipo iMin
              swift pro 2
            </li>
          </ul>
          <div class="mt-4">
            <a
              href="https://play.google.com/store/apps/details?id=uy.fixed.feapp"
              target="_blank"
              style="
                background: #34a853;
                color: #fff;
                padding: 9px 16px;
                border-radius: 8px;
                text-decoration: none;
                font-weight: 600;
                margin-right: 8px;
                display: inline-block;
              "
              >Descargar en Google Play</a
            >
            <!-- <a
              href="https://apps.apple.com/app/idTUAPPID"
              style="
                background: #007aff;
                color: #fff;
                padding: 9px 16px;
                border-radius: 8px;
                text-decoration: none;
                font-weight: 600;
                display: inline-block;
              "
              >Descargar en App Store</a
            > -->
          </div>
        </div>
      </Preview>
    </Alert>
  </template>
</template>
